import { flexRender, type HeaderGroup, type RowData, type TableFeatures } from '@tanstack/react-table';
import { column_getCanSort, column_getIsSorted, column_toggleSorting } from '@tanstack/react-table/static-functions';
import SortableHeaderCellReward from '../SortableHeaderCellReward';
import { TableReward } from '../TableReward';
export interface TrHeaderGroupRewardProps<TFeatures extends TableFeatures, T extends RowData> {
  headerGroup: HeaderGroup<TFeatures, T>;
  columnLabels?: Record<string, string>;
}
export function TrHeaderGroupReward<TFeatures extends TableFeatures, T extends RowData>({
  headerGroup,
  columnLabels
}: TrHeaderGroupRewardProps<TFeatures, T>) {
  // 'use no memo': TanStack keeps this object's reference while table state (sorting, rows) changes.
  'use no memo';

  return <TableReward.Tr>
      {headerGroup.headers.map(header => <SortableHeaderCellReward key={header.id} colSpan={header.colSpan}
    // oxlint-disable-next-line typescript/consistent-type-assertions
    columnName={columnLabels?.[header.id as keyof typeof columnLabels]} isSorted={column_getIsSorted(header.column)} isSortable={column_getCanSort(header.column)} onClick={() => {
      if (column_getCanSort(header.column)) column_toggleSorting(header.column);
    }}>
          {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
        </SortableHeaderCellReward>)}
    </TableReward.Tr>;
}